import type { ApiClient } from '../../@sprinx/react-after-razzle';

type CurrentMonthOrderSummaryParams = {
  contactId: string;
};

export type CurrentMonthOrderSummary = {
  leftToContactLimit: number;
  sumOrderTotalsInCurrentMonth: number | null;
  totalOrderLimit: number | null;
};

export async function getCurrentMonthOrderSummary(
  apiClient: ApiClient,
  data: CurrentMonthOrderSummaryParams,
): Promise<CurrentMonthOrderSummary> {
  return apiClient.get<CurrentMonthOrderSummary, {}>('/v1/orders/current-month-order-summary', data);
}
